import React from "react";
import CommonModal from "../../../../components/Common/CommonModal";
import Moment from "react-moment";
import Format from "../../../../helpers/Format";
import ItemTimelineVertical from "../../../../components/timeline/ItemTimelineVertical";
import WrapperTimelineVertical from "../../../../components/timeline/WrapperTimelineVertical";
import PropTypes from "prop-types";

function HistoricoModal({
  modalHook,
  valuesHook,
  downloadDocumento,
  excluirDocumento,
}) {
  const { historicoModal, setHistoricoModal } = modalHook;
  const { values } = valuesHook;

  return (
    <CommonModal
      title="Histórico"
      is_open_modal={historicoModal}
      set_is_open_modal={setHistoricoModal}
      size="lg"
    >
      <div className="row mb-3">
        <h4>Informações originais</h4>
        <div className="col-12" id="informacoes_originiais">
          <h5>
            Descrição:{" "}
            <span style={{ fontWeight: 400 }}>{values?.descricao}</span>
          </h5>
          <h5>
            Categoria:{" "}
            <span style={{ fontWeight: 400 }}>{values?.categoria}</span>
          </h5>
          <h5>
            Vencimento:{" "}
            <span style={{ fontWeight: 400 }}>
              <Moment format="DD/MM/YYYY">
                {values?.historico?.data_vencimento}
              </Moment>
            </span>
          </h5>
          <h5>
            Valor:{" "}
            <span style={{ fontWeight: 400 }}>
              {Format.formataValor(values?.historico?.valor || 0)}
            </span>
          </h5>
        </div>
      </div>
      <div>
        <h4>Arquivos</h4>
        <div className="col-12" id="documentos_timeline">
          <WrapperTimelineVertical>
            {values?.documentos &&
              values.documentos.map((documento, index) =>
                documento?.ativo === 0 ? (
                  <></>
                ) : (
                  <ItemTimelineVertical
                    key={`historico-${index}`}
                    titulo={
                      index === 0 ? "Arquivo original" : `Recálculo ${index}`
                    }
                    icone="bx bx-copy-alt"
                  >
                    <button
                      style={{
                        color: "#8AB4F8",
                        textDecoration: "underline",
                        backgroundColor: "transparent",
                        border: "0px transparent",
                        padding: "0px",
                      }}
                      onClick={() => {
                        downloadDocumento(
                          documento.caminho,
                          index === 0
                            ? "Arquivo original"
                            : `Recálculo ${index}`
                        );
                      }}
                    >
                      Download
                    </button>
                    {index === 0 || index === values.documentos.length - 1 ? (
                      <></>
                    ) : (
                      <>
                        {" "}
                        -{" "}
                        <button
                          style={{
                            color: "#FF484B",
                            textDecoration: "underline",
                            backgroundColor: "transparent",
                            border: "0px transparent",
                            padding: "0px",
                          }}
                          onClick={() => {
                            excluirDocumento(index);
                          }}
                        >
                          Excluir
                        </button>
                      </>
                    )}
                    <p className="text-muted">
                      <div>
                        Data de upload:{" "}
                        <Moment format="DD/MM/YYYY">
                          {documento.data_upload}
                        </Moment>
                      </div>
                      {documento?.nova_data_vencimento && (
                        <div>
                          Data de vencimento:{" "}
                          <Moment format="DD/MM/YYYY">
                            {documento.nova_data_vencimento}
                          </Moment>
                        </div>
                      )}
                    </p>
                  </ItemTimelineVertical>
                )
              )}
          </WrapperTimelineVertical>
        </div>
      </div>
    </CommonModal>
  );
}

HistoricoModal.propTypes = {
  modalHook: PropTypes.shape({
    historicoModal: PropTypes.bool.isRequired,
    setHistoricoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  downloadDocumento: PropTypes.func.isRequired,
  excluirDocumento: PropTypes.func.isRequired,
};

export default HistoricoModal;
